import React, { PureComponent } from 'react'
import { unreadIndicator } from '../../Email/EmailUtils'
import UTM from '../../../utils/UTM'
import EmailLinkWrapper from './StyledEmailLinkWrapper'
import EmailAddress from './StyledEmailAddress'
import UnreadIndicator from '../../Email/StyledUnreadIndicator'
import TextLink from './StyledTextLink'

class EmailLinkFull extends PureComponent {
  render () {
    const {
      box,
      widget: {
        meta: {
          logout,
          inbox
        },
        utmMedium,
        utmSource
      }
    } = this.props
    const inboxLink = new UTM(inbox.location).getUTMLink({utmMedium, utmSource})

    return (
      <EmailLinkWrapper>
        <EmailAddress>
          { box.sender.address }
        </EmailAddress>
        <UnreadIndicator className={box.foldersummary.unread === 0 ? 'grey' : ''} full>
          { unreadIndicator(box.foldersummary.unread) }
        </UnreadIndicator>
        <TextLink href={inboxLink}>
          { inbox.text }
        </TextLink>
        <TextLink href={logout.location}>
          { logout.text }
        </TextLink>
      </EmailLinkWrapper>
    )
  }
}

export default EmailLinkFull
